import {
  Shop,
  Speedometer2,
  Truck,
  GraphUp,
  Receipt,
  InfoCircleFill,
  ChatDotsFill,
  FileEarmarkTextFill,
} from "react-bootstrap-icons";

// Single source of truth for the public "Quick Links" shown on both the
// desktop Footer and the Account page (mobile relies on Account instead of
// the footer, so the two lists must stay identical).
export const QUICK_LINKS = [
  { label: "About Us", to: "/about", desc: "Learn more about us", Icon: InfoCircleFill },
  { label: "Contact", to: "/contact", desc: "Get in touch with us", Icon: ChatDotsFill },
  { label: "Privacy Policy", to: "/privacy", desc: "How we handle your data", Icon: FileEarmarkTextFill },
  { label: "Terms of Service", to: "/terms", desc: "Usage rules and policies", Icon: FileEarmarkTextFill },
];

export const CLAIM_ORDER = ["elite", "operations", "sales", "merchant", "customer"];

export function claimFromClaims(claims) {
  return CLAIM_ORDER.find((c) => claims?.[c]) ?? "customer";
}

// Role dashboard shortcuts (excludes "customer", which Account.tsx renders
// as its own dedicated rows rather than a single tile).
export const ROLE_TILES = {
  merchant: { label: "Catalog", desc: "Manage product listings", Icon: Shop, path: (user) => `/store/catalog/${user?.uid}` },
  elite: { label: "Admin", desc: "Super admin tools", Icon: Speedometer2, path: () => "/sup/" },
  operations: { label: "Deliveries", desc: "Rider & delivery tools", Icon: Truck, path: () => "/ops/deliveries" },
  sales: { label: "Analytics", desc: "Sales & performance", Icon: GraphUp, path: () => "/sales/dashboard" },
};

const CUSTOMER_TILE = { label: "My Orders", desc: "View your order history", Icon: Receipt, path: () => "/account/orders" };

// Resolves the one role-appropriate shortcut for a signed-in user, for
// surfaces (like the Footer) that show a single link rather than a full
// per-role section.
export function getRoleQuickLink(claim, user) {
  if (claim === "customer") return { ...CUSTOMER_TILE, path: CUSTOMER_TILE.path(user) };
  const tile = ROLE_TILES[claim];
  return tile ? { ...tile, path: tile.path(user) } : null;
}
